import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import { Box, Typography } from "@mui/material";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { Toolbar } from "../../components/ui/toolbar/toolbar.component";
import { Action } from "../../types/toolbar";
import { SETTLEMENT_KIND_OPTIONS } from "../../consts";
import { serviceActionsSectionStyle } from "../../styles/commonStyles";

export const SettlementsStatisticsActions = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const params = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const settlementKindParam = params.get("settlement_kind") || "";

  const updateSettlementKindParam = (value?: string) => {
    const nextParams = new URLSearchParams(location.search);

    if (value) {
      nextParams.set("settlement_kind", value);
    } else {
      nextParams.delete("settlement_kind");
    }

    const nextSearch = nextParams.toString();
    navigate({
      pathname: location.pathname,
      search: nextSearch ? `?${nextSearch}` : "",
    });
  };

  const quickFilterActions: Action[] = [
    {
      icon: <FilterAltOutlinedIcon />,
      label: t("All settlement kinds"),
      onClick: () => updateSettlementKindParam(undefined),
      color: !settlementKindParam ? "var(--primaryColor)" : undefined,
    },
    ...SETTLEMENT_KIND_OPTIONS.map((option) => ({
      icon: <FilterAltOutlinedIcon />,
      label: t(option.labelKey),
      onClick: () => updateSettlementKindParam(option.value),
      color: settlementKindParam === option.value ? "var(--primaryColor)" : undefined,
    })),
  ];

  const quickFilters = (
    <Box component="fieldset" sx={serviceActionsSectionStyle}>
      <Typography
        component="legend"
        variant="subtitle2"
        sx={{
          px: 1,
          mb: 1,
        }}
      >
        {t("Quick filters")}
      </Typography>
      <Toolbar actions={quickFilterActions} noTopPadding showShortcut={false} />
    </Box>
  );

  return (
    <Box sx={{ display: "flex", flexDirection: "column", width: "100%", height: "100%", minHeight: 0 }}>
      {quickFilters}
      <Box sx={{ flex: 1, minHeight: 0 }}>
        <Toolbar actions={[]} noTopPadding />
      </Box>
    </Box>
  );
};
